import React from "react";
import videojs from "video.js";
import classNames from "classnames";
import { gtag } from "../../utils";
import UseQuery from "../../utils/useQuery";

import "./style.scss";

export default class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.autoplay && this.props.autoplay.value) {
      this.state = { videoIsPlaying: true, stop: true, scrollTop:0 };
    } else {
      this.state = { videoIsPlaying: false, stop: true, scrollTop:0 };
    }

    this.playPressed = this.playPressed.bind(this);
    this.pausePressed = this.pausePressed.bind(this);
    this.videoEnded = this.videoEnded.bind(this);
    this.videoLoaded = this.videoLoaded.bind(this);
    this.videoTimeupdate = this.videoTimeupdate.bind(this);
  }

  componentDidMount(props) {
    window.addEventListener("scroll", this.handleScroll);

    // instantiate video.js
    // this.props=this.props.src
    // {
    //   title: "lorem ipsum",
    //   controls: true,
    //   videoTitle: "Lorem ispsum dolor",
    //   replayText: "loren ipsum",
    //   poster:
    //     "https://wpblobstoragestage.blob.core.windows.net/images/one_one/interiors.png",
    //   sources: [
    //     {
    //       src:
    //         "https://coalbstage.blob.core.windows.net/design-system-static-stage/Lynk+&+Co+_+Birth+of+Lynk+&+Co.mp4",
    //       type: "video/mp4"
    //     }
    //   ]
    // }

    this.player = videojs(this.videoNode, this.props, function onPlayerReady() {
      // console.log("onPlayerReady", this);
    });
    if (this.props.muted) {
      this.player.muted(this.props.muted);
    }
    this.player.playsinline(true);
    if (this.props.autoplay && this.props.autoplay.value) {
      this.player.muted(true);
      this.player.autoplay(true);
    } else {
      this.player.autoplay(false);
    }
    this.player.on("playing", this.playPressed);

    this.player.on("pause", this.pausePressed);

    this.player.on("ended", this.videoEnded);

    this.player.on("progress", this.videoLoaded);
    this.player.on("timeupdate", this.videoTimeupdate);
    this.player.on("fullscreenchange", v=>{
      if(!document.fullscreenElement){
        // document.getElementsByTagName('html')[0].className = '';
      }else{
        console.log(document.documentElement.scrollTop)
        // document.getElementsByTagName('html')[0].className = 'modal-open';
      }
    })
    const query = UseQuery();
    if (query.noHeaderFooter) {
      let elementsToShow = document.querySelectorAll(".vjs-fullscreen-control.vjs-control.vjs-button");
      let arr = [];
      arr.forEach.call(elementsToShow, function(element) {
        element.style.display = "none";
      });
    }
  }

  handleScroll = event => {
    let elem = this.video;
    if (elem === undefined) {
      return;
    }
    let rect = elem.getBoundingClientRect();
    let winHeight = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top <= 0 && rect.bottom >= winHeight) return;
    if (!((rect.top >= 0 && rect.top <= winHeight) || (rect.bottom >= 0 && rect.bottom <= winHeight))) {
      this.setState({ videoIsPlaying: false });
      if(!document.fullscreenElement){
        this.player.pause();
      }
    }
  };

  playPressed = () => {
    this.setState({ videoIsPlaying: true, stop: false});
    if (this.props.videoPlayPressed) {
      this.props.videoPlayPressed();
    }
  };

  pausePressed = () => {
    this.setState({ videoIsPlaying: true, stop: true });
    if (this.props.videoPausePressed) {
      this.props.videoPausePressed();
    }
  };

  videoEnded = () => {
    if (this.props.videoEnded) {
      this.props.videoEnded();
    }
  };
  videoLoaded = () => {
    if (this.props.videoLoaded) {
      this.props.videoLoaded();
    }
  };
  videoTimeupdate = () => {
    if (this.props.videoTimeupdate) {
      this.props.videoTimeupdate();
    }
  };
  videoClick = () => {
    gtag('event', 'Component_info', {
      'component_name': 'BrandImageList',
      'page_title': this?.props?.page?.name
    });
    if (!this.state.stop) {
      this.player.pause();
      window.removeEventListener("scroll", this.handleScroll);
    }
    if (this.state.stop) {
      this.player.play();
      window.removeEventListener("scroll", this.handleScroll);
    }
  }
  componentWillUnmount() {
    if (this.player) {
      this.player.dispose();
    }

    window.removeEventListener("scroll", this.handleScroll);
  }

  // pause player when changing video in carousel
  componentDidUpdate() {
    if (this.state.videoIsPlaying && this.props.forceVideoPause) {
      this.setState({ videoIsPlaying: false });
      this.player.pause();
    }
  }

  // wrap the player in a div with a `data-vjs-player` attribute
  // so videojs won't create additional wrapper in the DOM
  // see https://github.com/videojs/video.js/pull/3856
  render() {
    const infoClasses = classNames("center-info-node",{
      "is-playing": true,//this.state.videoIsPlaying
      "play": true
    });
    return (
      <div className={"video-container"} ref={e => (this.video = e)}>
        <div data-vjs-player className={"vjs-player"}>
          <video ref={node => (this.videoNode = node)} className="video-js" webkit-playsinline="true" playsInline />
          {!this.props.autoplay?.value && <div className={infoClasses} onClick={this.videoClick.bind(this)} >{this.props.videoTitle && <span className={"video-title"}>{this.props.videoTitle}</span>}</div>}
        </div>
      </div>
    );
  }
}
